import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { AppState, Auth0Provider } from '@auth0/auth0-react';
import * as Sentry from '@sentry/react';

import { ConfigProvider } from 'antd';
import { createBrowserHistory } from 'history';
import { AuthTokenProvider } from 'providers/AuthTokenProvider';
import { ToastProvider } from 'providers/ToastProvider';
import { store } from './app-redux/store';
import { App } from './App';
import reportWebVitals from './reportWebVitals';

import './index.scss';
import 'antd/dist/reset.css';

const history = createBrowserHistory();

const domain = process.env.REACT_APP_AUTH0_DOMAIN_URL ?? '';
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID ?? '';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_SENTRY_ENV,
  debug: true,
  enabled: true,
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 1.0,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      maskAllInputs: false,
      mask: ['.data-sentry-block'],
      networkDetailAllowUrls: [window.location.origin],
      networkRequestHeaders: ['X-Custom-Header'],
      networkResponseHeaders: ['X-Custom-Header'],
    }),
  ],
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const onRedirectCallback = (appState?: AppState) => {
  history.push(appState && appState.returnTo ? appState.returnTo : '/');
};

const queryParams = new URLSearchParams(window.location.search);
const prompt = queryParams.get('prompt') ?? '';

root.render(
  <Auth0Provider
    domain={domain}
    clientId={clientId}
    onRedirectCallback={onRedirectCallback}
    authorizationParams={{
      redirect_uri: window.location.origin,
      prompt: prompt === 'login' || prompt === 'none' ? prompt : undefined,
    }}
  >
    <Provider store={store}>
      <AuthTokenProvider>
        <ConfigProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </ConfigProvider>
      </AuthTokenProvider>
    </Provider>
  </Auth0Provider>
);

reportWebVitals();
